import { inboundConstants } from '../../_constants';
import { inboundServices } from '../../_services';
import { alertActions, notificationActions, confirmPromptActions, userActions, } from '../index';
import { CroPdf, CTSCDRPdf, VANINCLEARANCEPDF } from '../../../components/layout/InBoundPdf';
// import { TruckerWB } from '../../../components/layout/OutBoundPdf/AllOutBoundPdf';
import { search_word, makeid } from '../../../Functions';
export const inboundActions = {
    resetInbound,

    //unloadlist
    createUnLoadList,
    groupUnLoadListbyRelease,
    deleteUnLoadListByRelease,
    updateUnLoadListReleaseType,
    acknowledgeUnLoadListRelease,
    updateUnLoadList,

    getUnLoadListbyReleaseType,
    unLoadList,
    getVoyageDestination,
    getForUnloadingCreation,
    moveTallySheetToUnload,
    removeTallySheetUnLoadList,
    //cargo arrival notice
    inBoundUnloadingConfirmationVoyage,
    getUnLoadingConfirmationByVoyageNum,
    readcargoArrivalPerBookingRef,
    resetcargoArrivalPerBookingRef,
    //tallysheet
    getUnloadListForTallySheetCreation,
    createInboundTallySheet,
    readTallySheetByVoyageNum,
    readTallySheetCode,
    deleteInBoundTallySheet,
    updateInBoundTallySheet,
    updateUnloadingTallySheetIsFinal,
    //cargo release order,
    loadCRO,
    getBookingCRO,
    createInBoundCRO,
    getCRO,
    updateCRO,
    deleteCRO,

    // Cargo Delivery Receipt
    // loadCDR,
    // getBookingForCDR,
    // createCDR,
    // getCDR,
    // updateCDR,
    // deleteCDR,

    //CTS
    loadInboundCts,
    deleteInboundCTSNum,
    getCTS,
    getBookingInboundForCTS,
    getBookingInboundForCTSTandem,
    createBookingInBoundCts,
    createBookingInBoundCtsTandem,
    updateInboundCTSNum,

    // Voyage List
    getVoyageArrivalNotice,
    getVoyageUnloadList,
    getVoyageUnloadTallySheet,

    // Van-In
    loadVanIn,
    getContainerVanForVanIn,
    computeInboundDemmurage,
    getVanIn,
    createVanInEmpty,
    updateVanInEmpty,
    deleteVanInEmpty,
    // new
    getInboundCtsVanDetails,
    getInboundCtsTandemVanDetails,
    getInboundCtsDetails,
    computeInboundTandemDemmurage,
    getInboundCtsTandemDetails,
     
    // Vessel Arrival Notice
    getVesselArrivalNotice,
    getVesselArrivalNoticeByVoyageNum,

    // CRO Clearance
    getVoyageCroClearance,
    getCroClearance,
    updateIsClearedCRO,
    getCroUnpaidWaybills,

    // Dispatch Module
    getDispacthList,
    updateOutDispatchList,
    sendInDispatchList,
    archiveInDispatchList,
    readArchiveInDispatchList,

    // Dwell Time
    inboundDwelltimeReport,

    sendCANToConsigneeEmail,
}

function resetInbound() { return { type: inboundConstants.RESET } }
function resetcargoArrivalPerBookingRef() { return { type: inboundConstants.INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING_RESET } }

function inboundFetching() { return { type: inboundConstants.INBOUND_FETCHING } }
function inboundFetched() { return { type: inboundConstants.INBOUND_FETCHED } }

function inboundSubmitting() { return { type: inboundConstants.INBOUND_SUBMITTING } }
function inboundSubmitted() { return { type: inboundConstants.INBOUND_SUBMITTED } }

function sendCANToConsigneeEmail(payload) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.notallowLeavePage());
        inboundServices.sendCANToConsigneeEmail(payload)
            .then(
                ConsigneeEmail => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundFetched());
                    dispatch(success(makeid(8)));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(ConsigneeEmail) { return { type: inboundConstants.CONSIGNEE_EMAIL, ConsigneeEmail } }
}

// Dispatch Module
function getDispacthList(payload) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getDispacthList(payload)
            .then(
                DispatchList => {
                    dispatch(success(DispatchList));
                    dispatch(inboundFetched());
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(DispatchList) { return { type: inboundConstants.GET_DISPATCH_LIST, DispatchList } }
}
function updateOutDispatchList(payload) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateOutDispatchList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    setTimeout(() => {
                        window.location.href = `/inbound/dispatchModule`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function sendInDispatchList(payload, load) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.sendInDispatchList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(getDispacthList(load));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(getDispacthList(load));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function archiveInDispatchList(payload, load) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.archiveInDispatchList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(getDispacthList(load));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(getDispacthList(load));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function readArchiveInDispatchList(payload) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.readArchiveInDispatchList(payload)
            .then(
                ArchiveDispatchList => {
                    dispatch(success(ArchiveDispatchList));
                    dispatch(inboundFetched());
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(ArchiveDispatchList) { return { type: inboundConstants.GET_ARCHIVE_DISPATCH_LIST, ArchiveDispatchList } }
}

function getVoyageArrivalNotice(branchCode, search) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getVoyageArrivalNotice(branchCode, search)
            .then(
                voyageArrivalNoticeList => {
                    dispatch(inboundFetched());
                    // if (voyageArrivalNoticeList.length > 0) {
                    //     dispatch(success(voyageArrivalNoticeList));
                    // } else {
                    //     dispatch(success([]));
                    //     dispatch(alertActions.warning(voyageArrivalNoticeList.message));
                    // }
                    dispatch(success(voyageArrivalNoticeList));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(voyageArrivalNoticeList) { return { type: inboundConstants.GET_VOYAGE_ARRIVALNOTICE, voyageArrivalNoticeList } }
}
function getVoyageUnloadList(branchCode, search) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getVoyageUnloadList(branchCode, search)
            .then(
                voyageUnloadList => {
                    dispatch(inboundFetched());
                    // if (voyageUnloadList.length > 0) {
                    //     dispatch(success(voyageUnloadList));
                    // } else {
                    //     dispatch(success([]));
                    //     dispatch(alertActions.warning(voyageUnloadList.message));
                    // }
                    dispatch(success(voyageUnloadList));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(voyageUnloadList) { return { type: inboundConstants.GET_VOYAGE_UNLOADLIST, voyageUnloadList } }
}
function getVoyageUnloadTallySheet(branchCode, search) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getVoyageUnloadTallySheet(branchCode, search)
            .then(
                voyageUnloadlistTallysheet => {
                    dispatch(inboundFetched());
                    // if (voyageUnloadlistTallysheet.length > 0) {
                    //     dispatch(success(voyageUnloadlistTallysheet));
                    // } else {
                    //     dispatch(success([]));
                    //     dispatch(alertActions.warning(voyageUnloadlistTallysheet.message));
                    // }
                    dispatch(success(voyageUnloadlistTallysheet));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(voyageUnloadlistTallysheet) { return { type: inboundConstants.GET_VOYAGE_UNLOADLIST_TALLYSHEET, voyageUnloadlistTallysheet } }
}
function groupUnLoadListbyRelease(voyageNUm, branchDestination) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.groupUnLoadListbyRelease(voyageNUm, branchDestination)
            .then(
                groupUnloadlistByRelease => {
                    dispatch(inboundFetched());
                    if (groupUnloadlistByRelease.length > 0) {
                        dispatch(success(groupUnloadlistByRelease));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(groupUnloadlistByRelease.message ? groupUnloadlistByRelease.message : 'No data found.'));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(groupUnloadlistByRelease) { return { type: inboundConstants.INBOUND__GROUP_UNLOADLIST_BY_RELEASE, groupUnloadlistByRelease } }
}
function createUnLoadList(payload, voyageNUm, notification) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.createUnLoadList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Successfully added to unload list.'));
                    setTimeout(() => {
                        window.location.href = `/inbound/unloadList/${voyageNUm}`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function updateUnLoadListReleaseType(payload, branchDestination, notification) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateUnLoadListReleaseType(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success(`Release type successfully chaged to ${payload.releaseType}.`));
                    dispatch(groupUnLoadListbyRelease(payload.voyageNum, branchDestination));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function deleteUnLoadListByRelease(payload, branchDestination) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.deleteUnLoadListByRelease(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Unload List deleted successfully.'));
                    dispatch(groupUnLoadListbyRelease(payload.voyageNum, branchDestination));

                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function getUnLoadListbyReleaseType(voyageNUm, releaseId, destination, search) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getUnLoadListbyReleaseType(voyageNUm, releaseId, destination, search)
            .then(
                unloadlistByreleaseId => {
                    dispatch(inboundFetched());
                    dispatch(success(unloadlistByreleaseId));
                    if (unloadlistByreleaseId.message) {
                        dispatch(alertActions.warning(unloadlistByreleaseId.message ? unloadlistByreleaseId.message : 'No data found.'));
                        dispatch(success(null));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(unloadlistByreleaseId) { return { type: inboundConstants.INBOUND_UNLOADLIST_BY_RELEASE_ID, unloadlistByreleaseId } }
}
function acknowledgeUnLoadListRelease(payload, voyageNum, branchCode, notification) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.acknowledgeUnLoadListRelease(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Confirmed successfully.'));
                    dispatch(getUnLoadListbyReleaseType(voyageNum, payload.releaseId, branchCode));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            );
    }
}
function updateUnLoadList(payload, releaseId, branchCode, link, notification) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateUnLoadList(payload, releaseId)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success(payload.status === 'add' ? 'Successfully added to loadlist.' : 'Loadlist cancelled successfully.'));
                    if (payload.status === 'add') {
                        setTimeout(() => {
                            window.location.href = link;                            
                        }, 1000);
                    }
                    else dispatch(getUnLoadListbyReleaseType(payload.voyageNum, releaseId, branchCode));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            );
    }
}
function unLoadList(voyageNUm, destinationBranchCode) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.unLoadList(voyageNUm, destinationBranchCode)
            .then(
                unloadlistData => {
                    dispatch(inboundFetched());
                    dispatch(success(unloadlistData));
                    if (unloadlistData.message) {
                        dispatch(alertActions.warning(unloadlistData.message));
                        dispatch(success({}));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success({}));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(unloadlistData) { return { type: inboundConstants.INBOUND_UNLOADLIST_DATA, unloadlistData } }
}
function getVoyageDestination(voyageNUm) {
    return dispatch => {
        inboundServices.getVoyageDestination(voyageNUm)
            .then(
                inboundDestinations => {
                    if (inboundDestinations.length > 0) {
                        dispatch(success(inboundDestinations));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(inboundDestinations.message));
                    }
                },
                error => {
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundDestinations) { return { type: inboundConstants.INBOUND_DESTINATIONS, inboundDestinations } }
}
function getForUnloadingCreation(voyageNUm, destinationBranchCode) {
    return dispatch => {
        dispatch(userActions.allowLeavePage());
        dispatch(inboundFetching());
        inboundServices.getForUnloadingCreation(voyageNUm, destinationBranchCode)
            .then(
                unloadlistDataForCreate => {
                    dispatch(inboundFetched());
                    if (unloadlistDataForCreate.length > 0) {
                        dispatch(success(unloadlistDataForCreate));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(unloadlistDataForCreate.message ? unloadlistDataForCreate.message : 'No data found.'));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(unloadlistDataForCreate) { return { type: inboundConstants.INBOUND_UNLOADLIST_DATA_FOR_CREATE, unloadlistDataForCreate } }
}
function moveTallySheetToUnload(payload, voyageNUm, releaseId, destination, search) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.moveTallySheetToUnload(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (payload.releaseType === 'Partial Release') {
                        dispatch(alertActions.success('Unload list successfully added.'));
                        setTimeout(() => {
                            window.location.href = `/inbound/unloadList/${voyageNUm}`;                            
                        }, 1000);
                    } else if (payload.releaseType === 'Cancelled') {
                        dispatch(getUnLoadListbyReleaseType(voyageNUm, releaseId, destination, search))
                        dispatch(alertActions.success('Unload list successfully cancelled'));
                    } else if (payload.releaseType === 'Final Release') {
                        dispatch(getUnLoadListbyReleaseType(voyageNUm, releaseId, destination, search))
                        dispatch(alertActions.success('Unload list successfully released'));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function removeTallySheetUnLoadList(voyageNum, releaseId, branchDestination, search) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.removeTallySheetUnLoadList(voyageNum, releaseId, branchDestination)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getUnLoadListbyReleaseType(voyageNum, releaseId, branchDestination, search))
                    dispatch(alertActions.success('Unload list successfully removed'));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

//cargo arrival notice
function inBoundUnloadingConfirmationVoyage(branchCode) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.inBoundUnloadingConfirmationVoyage(branchCode)
            .then(
                canDestinations => {
                    dispatch(inboundFetched());
                    if (canDestinations.length > 0) {
                        dispatch(success(canDestinations));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(canDestinations.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(canDestinations) { return { type: inboundConstants.INBOUND_CAN_DESTINATIONS, canDestinations } }
}
function getUnLoadingConfirmationByVoyageNum(voyageNUm, voyageDestbranchCode) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getUnLoadingConfirmationByVoyageNum(voyageNUm, voyageDestbranchCode)
            .then(
                cargoArrivalNotice => {
                    dispatch(inboundFetched());
                    dispatch(success(cargoArrivalNotice));
                    if (cargoArrivalNotice.message) dispatch(alertActions.warning(cargoArrivalNotice.message));
                    dispatch(ConsigneeEmail(makeid(8)));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success({}));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(cargoArrivalNotice) { return { type: inboundConstants.INBOUND_CARGO_ARRIVAL_NOTICE, cargoArrivalNotice } }
    function ConsigneeEmail(ConsigneeEmail) { return { type: inboundConstants.CONSIGNEE_EMAIL, ConsigneeEmail } }
}
function readcargoArrivalPerBookingRef(payload) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.readcargoArrivalPerBookingRef(payload)
            .then(
                cargoArrivalPerBookingRef => {
                    dispatch(inboundFetched());
                    dispatch(success(cargoArrivalPerBookingRef));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(cargoArrivalPerBookingRef) { return { type: inboundConstants.INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING, cargoArrivalPerBookingRef } }
}
//tallysheet
function getUnloadListForTallySheetCreation(voyageNUm, destinationBranchCode) {
// function getUnloadListForTallySheetCreation(voyageNUm) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getUnloadListForTallySheetCreation(voyageNUm, destinationBranchCode)
        // inboundServices.getUnloadListForTallySheetCreation(voyageNUm)
            .then(
                unloadlistForTallySheetCreation => {
                    dispatch(inboundFetched());
                    // if (!unloadlistForTallySheetCreation.message) {
                        dispatch(success(unloadlistForTallySheetCreation));
                    // }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(unloadlistForTallySheetCreation) { return { type: inboundConstants.INBOUND_UNLOADLIST_FOR_TALLYSHEET_CREATION, unloadlistForTallySheetCreation } }
}
function createInboundTallySheet(payload, voyageNUm) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.createInboundTallySheet(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Successfully added to tally sheet.'));
                    setTimeout(() => {
                        window.location.href = `/inbound/tallySheet/${voyageNUm}`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function readTallySheetByVoyageNum(voyageNUm, branch) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.readTallySheetByVoyageNum(voyageNUm, branch)
            .then(
                tallySheetList => {
                    dispatch(inboundFetched());
                    dispatch(success(tallySheetList));
                    if (tallySheetList.message) dispatch(alertActions.warning(tallySheetList.message));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success({}));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(tallySheetList) { return { type: inboundConstants.INBOUND_TALLYSHEET_LIST, tallySheetList } }
}
function readTallySheetCode(tallysheetCode, text) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.readTallySheetCode(tallysheetCode)
            .then(
                tallySheet => {
                    if(text === 'read'){
                        dispatch(inboundFetched());
                    }
                    dispatch(success(tallySheet));
                    if (tallySheet.message) dispatch(alertActions.warning(tallySheet.message));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success({}));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(tallySheet) { return { type: inboundConstants.INBOUND_TALLYSHEET_BY_CODE, tallySheet } }
}
function deleteInBoundTallySheet(id, type, voyageNum, branchCode) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.deleteInBoundTallySheet(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Inbound tallysheet was deleted successfully'));
                    if (type === 'specific') {
                        setTimeout(() => {
                            window.location.href = `/inbound/tallySheet/${voyageNum}`;
                        }, 1000);
                    }
                    else dispatch(readTallySheetByVoyageNum(voyageNum, branchCode));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function updateInBoundTallySheet(voyageNUm, tallysheetCode, payload) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateInBoundTallySheet(tallysheetCode, payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Successfully updated to tally sheet.'));
                    setTimeout(() => {
                        window.location.href = `/inbound/tallySheet/${voyageNUm}`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function updateUnloadingTallySheetIsFinal(tallysheetCode, payload) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateUnloadingTallySheetIsFinal(tallysheetCode, payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Successfully updated to tally sheet.'));
                    dispatch(readTallySheetCode(tallysheetCode));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

// CRO
function loadCRO(skip, take, filter, search, userBranch) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.loadCRO(skip, take, filter, search, userBranch)
            .then(
                cargoReleaseOrder => {
                    dispatch(inboundFetched());
                    if (cargoReleaseOrder.length > 0) {
                        dispatch(success(cargoReleaseOrder));
                    } else {
                        dispatch(success(null));
                        dispatch(alertActions.warning(cargoReleaseOrder.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(cargoReleaseOrder) { return { type: inboundConstants.INBOUND_CRO, cargoReleaseOrder } }
}
function getBookingCRO(bookingRef, branch) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getBookingCRO(bookingRef, branch)
            .then(
                croByBooking => {
                    dispatch(inboundFetched());
                    dispatch(success(croByBooking));
                    if (croByBooking.message) dispatch(alertActions.warning(croByBooking.message));
                },
                error => {
                    dispatch(inboundFetched());
                   
                    dispatch(alertActions.error(error.toString()));
                    if(search_word(error.toString(), 'in BASE Accounting') === 'in BASE Accounting'){
                        dispatch(success({ isUnpaid: true }));
                    } else {
                        dispatch(success({ isUnpaid: false }));
                    }
                }
            )
    }
    function success(croByBooking) { return { type: inboundConstants.INBOUND_CRO_BY_BOOKING, croByBooking } }
}
function createInBoundCRO(payload, data, user) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.createInBoundCRO(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Cargo release order created successfully.'));
                    CroPdf({ ...data, cargorReleaseOrderId: success.cargorReleaseOrderId }, user);
                    setTimeout(() => {
                        window.location.href = `/inbound/cargoReleaseOrder`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function getCRO(cargorReleaseOrderId) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getCRO(cargorReleaseOrderId)
            .then(
                croByReleaseOrderId => {
                    dispatch(inboundFetched());
                    dispatch(success(croByReleaseOrderId));
                    if (croByReleaseOrderId.message) {
                        dispatch(success(null));
                        dispatch(alertActions.warning(croByReleaseOrderId.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success({}));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(croByReleaseOrderId) { return { type: inboundConstants.INBOUND_CRO_BY_RELEASE_ORDER_ID, croByReleaseOrderId } }
}
function updateCRO(cargorReleaseOrderId, payload) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateCRO(cargorReleaseOrderId, payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Cargo release order updated successfully.'));
                    setTimeout(() => {
                        window.location.href = `/inbound/cargoReleaseOrder`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function deleteCRO(id, type, userBranch) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.deleteCRO(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Cargo release order was deleted successfully'));
                    if (type === 'specific') {
                        setTimeout(() => {
                            window.location.href = `/inbound/cargoReleaseOrder`;                            
                        }, 1000);
                    }
                    else dispatch(loadCRO(0, 20, null, null, userBranch));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

// Cargo Delivery Receipt
// function loadCDR(skip, take, filter, search, userBranch) {
//     return dispatch => {
//         dispatch(inboundFetching());
//         inboundServices.loadCDR(skip, take, filter, search, userBranch)
//             .then(
//                 cargoDeliveryReceipt => {
//                     dispatch(inboundFetched());
//                     if (cargoDeliveryReceipt.length > 0) {
//                         dispatch(success(cargoDeliveryReceipt));
//                     } else {
//                         dispatch(success(null));
//                         dispatch(alertActions.warning(cargoDeliveryReceipt.message));
//                     }
//                 },
//                 error => {
//                     dispatch(inboundFetched());
//                     dispatch(success(null));
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             )
//     }
//     function success(cargoDeliveryReceipt) { return { type: inboundConstants.INBOUND_CDR, cargoDeliveryReceipt } }
// }
// function getBookingForCDR(bookingRef) {
//     return dispatch => {
//         dispatch(inboundFetching());
//         inboundServices.getBookingForCDR(bookingRef)
//             .then(
//                 CDRByBooking => {
//                     dispatch(inboundFetched());
//                     dispatch(success(CDRByBooking));
//                     if (CDRByBooking.message) dispatch(alertActions.warning(CDRByBooking.message));
//                 },
//                 error => {
//                     dispatch(inboundFetched());
//                     dispatch(success({}));
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             )
//     }
//     function success(CDRByBooking) { return { type: inboundConstants.INBOUND_CDR_BY_BOOKING, CDRByBooking } }
// }
// function createCDR(payload, user, printPayload) {
//     return dispatch => {
//         dispatch(inboundSubmitting());
//         inboundServices.createCDR(payload)
//             .then(
//                 success => {
//                     dispatch(inboundSubmitted());
//                     dispatch(alertActions.success('Cargo Delivery Receipt created successfully.'));
//                     window.location.href = `/inbound/cargoDeliveryReceipt`;
//                     CDRPdf({ ...printPayload, cargoDeliveryReceiptId: success.cargoDeliveryReceiptId }, user);
//                 },
//                 error => {
//                     dispatch(inboundSubmitted());
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             )
//     }
// }
// function getCDR(cdrId) {
//     return dispatch => {
//         dispatch(inboundFetching());
//         inboundServices.getCDR(cdrId)
//             .then(
//                 CDRById => {
//                     dispatch(inboundFetched());
//                     dispatch(success(CDRById));
//                     if (CDRById.message) {
//                         dispatch(success(null));
//                         dispatch(alertActions.warning(CDRById.message));
//                     }
//                 },
//                 error => {
//                     dispatch(inboundFetched());
//                     dispatch(success({}));
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             )
//     }
//     function success(CDRById) { return { type: inboundConstants.INBOUND_CDR_BY_ID, CDRById } }
// }
// function updateCDR(cargorReleaseOrderId, payload, user, printPayload) {
//     return dispatch => {
//         dispatch(inboundSubmitting());
//         inboundServices.updateCDR(cargorReleaseOrderId, payload)
//             .then(
//                 success => {
//                     dispatch(inboundSubmitted());
//                     dispatch(alertActions.success('Cargo Delivery Receipt updated successfully.'));
//                     window.location.href = `/inbound/cargoDeliveryReceipt`;
//                     CDRPdf(printPayload, user);
//                 },
//                 error => {
//                     dispatch(inboundSubmitted());
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             )
//     }
// }
// function deleteCDR(id, type, userBranch) {
//     return dispatch => {
//         inboundServices.deleteCDR(id)
//             .then(
//                 success => {
//                     dispatch(confirmPromptActions.hide());
//                     dispatch(alertActions.success('Cargo Delivery Receipt was deleted successfully'));
//                     if (type === 'specific') window.location.href = `/inbound/cargoDeliveryReceipt`;
//                     else dispatch(loadCDR(0, 20, null, null, userBranch));
//                 },
//                 error => {
//                     dispatch(confirmPromptActions.hide());
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             )
//     }
// }

// CTS
function loadInboundCts(skip, take, filter, search, userBranch) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.loadInboundCts(skip, take, filter, search, userBranch)
            .then(
                inboundCts => {
                    dispatch(inboundFetched());
                    if (inboundCts.length > 0) {
                        dispatch(success(inboundCts));
                    } else {
                        dispatch(success(null));
                        dispatch(alertActions.warning(inboundCts.message ? inboundCts.message : 'No more data'));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundCts) { return { type: inboundConstants.INBOUND_CTS, inboundCts } }
}
function deleteInboundCTSNum(id, type, userBranch) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.deleteInboundCTSNum(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Cts was deleted successfully'));
                    if (type === 'specific') {
                        setTimeout(() => {
                            window.location.href = `/inbound/cts`;                            
                        }, 1000);
                    }
                    else dispatch(loadInboundCts(0, 20, '', '', userBranch));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(loadInboundCts(0, 20, '', '', userBranch));
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function getCTS(CtsNum, action) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getCTS(CtsNum)
            .then(
                inboundCtsById => {
                    dispatch(inboundFetched());
                    if (inboundCtsById.length > 0) {
                        if(action && action === 'clerance') {
                            VANINCLEARANCEPDF(inboundCtsById[0]);
                        }
                        else{
                            dispatch(success(inboundCtsById));
                        }
                    } else {
                        dispatch(success(null));
                        dispatch(alertActions.warning(inboundCtsById.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundCtsById) { return { type: inboundConstants.INBOUND_CTS_BY_ID, inboundCtsById } }
}
function getBookingInboundForCTS(bookingRef, branch) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getBookingInboundForCTS(bookingRef, branch)
            .then(
                inboundCtsByBooking => {
                    dispatch(inboundFetched());
                    if (inboundCtsByBooking.length > 0) {
                        dispatch(success(inboundCtsByBooking));
                    } else {
                        dispatch(success(null));
                        dispatch(alertActions.warning(inboundCtsByBooking.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundCtsByBooking) { return { type: inboundConstants.INBOUND_CTS_BY_BOOKING, inboundCtsByBooking } }
}
function getBookingInboundForCTSTandem(bookingRef, branch) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getBookingInboundForCTSTandem(bookingRef, branch)
            .then(
                inboundCtsByBookingTandem => {
                    dispatch(inboundFetched());
                    if (inboundCtsByBookingTandem.length > 0) {
                        dispatch(success(inboundCtsByBookingTandem));
                    } else {
                        dispatch(success(null));
                        dispatch(alertActions.warning(inboundCtsByBookingTandem.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundCtsByBookingTandem) { return { type: inboundConstants.INBOUND_CTS_BY_BOOKING_TANDEM, inboundCtsByBookingTandem } }
}
function createBookingInBoundCts(payload, user, printPayload, isTandem, wbTrData) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.createBookingInBoundCts(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    let PrintLoad = printPayload;
                    PrintLoad[0].ctsNum = success.ctsNum;
                    PrintLoad[0].cargoDeliveryReceiptId = success.ctsNum;
                    // CTSCDRPdf({ ...printPayload, ctsNum: success.ctsNum, cargoDeliveryReceiptId: success.ctsNum }, user);
                    if(isTandem){
                        PrintLoad[1].ctsNum = success.ctsNum;
                        PrintLoad[1].cargoDeliveryReceiptId = success.ctsNum;
                        if(wbTrData){
                            let wbTrDataF = {...wbTrData};
                            wbTrDataF.ctsNum = success.ctsNum;
                            // TruckerWB(wbTrDataF)
                            CTSCDRPdf(PrintLoad, user, wbTrDataF);
                        }
                        else {
                            CTSCDRPdf(PrintLoad, user, null);
                        }

                        dispatch(alertActions.success('Cts created successfully.'));
                        setTimeout(() => {
                            window.location.href = `/inbound/cts`;                            
                        }, 1000);
                    }
                    else {
                        if(wbTrData){
                            let wbTrDataF = {...wbTrData};
                            wbTrDataF.ctsNum = success.ctsNum;
                            // TruckerWB(wbTrDataF)
                            CTSCDRPdf(PrintLoad, user, wbTrDataF);
                        }
                        else {
                            CTSCDRPdf(PrintLoad, user, null);
                        }

                        dispatch(alertActions.success('Cts created successfully.'));
                        setTimeout(() => {
                            window.location.href = `/inbound/cts`;                            
                        }, 1000);
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function createBookingInBoundCtsTandem(payload, user, printPayload) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.createBookingInBoundCts(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Cts created successfully.'));
                    CTSCDRPdf({ ...printPayload, ctsNum: success.ctsNum, cargoDeliveryReceiptId: success.ctsNum }, user, null);
                    setTimeout(() => {
                        window.location.href = `/inbound/cts`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function updateInboundCTSNum(payload, CtsNum, user, PrintPayload, isTandem) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateInboundCTSNum(payload, CtsNum)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Cts updated successfully.'));
                    let PrintLoad = PrintPayload;
                    PrintLoad[0].ctsNum = CtsNum;
                    PrintLoad[0].cargoDeliveryReceiptId = CtsNum;
                    if(isTandem){
                        PrintLoad[1].ctsNum = CtsNum;
                        PrintLoad[1].cargoDeliveryReceiptId = CtsNum;
                    }
                    CTSCDRPdf(PrintLoad, user, null);
                    setTimeout(() => {
                        window.location.href = `/inbound/cts`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

// Van-In
function computeInboundDemmurage(load) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.computeInboundDemmurage(load)
            .then(
                inboundDemmurage => {
                    dispatch(inboundFetched());
                    dispatch(success(inboundDemmurage));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success('error'));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundDemmurage) { return { type: inboundConstants.INBOUND_DEMMURAGE, inboundDemmurage } }
}
function computeInboundTandemDemmurage(load) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.computeInboundDemmurage(load)
            .then(
                inboundTandemDemmurage => {
                    dispatch(inboundFetched());
                    dispatch(success(inboundTandemDemmurage));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success('error'));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundTandemDemmurage) { return { type: inboundConstants.INBOUND_TANDEM_DEMMURAGE, inboundTandemDemmurage } }
}
function loadVanIn(skip, take, search, userBranch) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.loadVanIn(skip, take, search, userBranch)
            .then(
                inboundloadVanIn => {
                    dispatch(inboundFetched());
                    if (inboundloadVanIn.length > 0) {
                        dispatch(success(inboundloadVanIn));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(inboundloadVanIn.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundloadVanIn) { return { type: inboundConstants.INBOUND_LOAD_VANIN_EMPTY, inboundloadVanIn } }
}
function getContainerVanForVanIn() {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getContainerVanForVanIn()
            .then(
                containerVanForVanIn => {
                    dispatch(inboundFetched());
                    if (containerVanForVanIn.length > 0) {
                        dispatch(success(containerVanForVanIn));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(containerVanForVanIn.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(containerVanForVanIn) { return { type: inboundConstants.GET_CONTAINER_VAN_FOR_VANIN, containerVanForVanIn } }
}
function getVanIn(ctsNum) {
    return dispatch => {
        dispatch(inboundFetching());
        dispatch(userActions.allowLeavePage());
        inboundServices.getVanIn(ctsNum)
            .then(
                inboundGetVanInById => {
                    dispatch(inboundFetched());
                    dispatch(success(inboundGetVanInById));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundGetVanInById) { return { type: inboundConstants.INBOUND_GET_VANIN_BY_ID, inboundGetVanInById } }
}
function getInboundCtsVanDetails(branch, container) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getInboundCtsVanDetails(branch, container)
            .then(
                CtsVanDetails => {
                    dispatch(inboundFetched());
                    dispatch(success(CtsVanDetails));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(CtsVanDetails) { return { type: inboundConstants.INBOUND_GET_CTS_VAN_DETAILS, CtsVanDetails } }
}
function getInboundCtsTandemVanDetails(branch, container) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getInboundCtsVanDetails(branch, container)
            .then(
                CtsVanTandemDetails => {
                    dispatch(inboundFetched());
                    dispatch(success(CtsVanTandemDetails));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(CtsVanTandemDetails) { return { type: inboundConstants.INBOUND_GET_CTS_VAN_TANDEM_DETAILS, CtsVanTandemDetails } }
}
function getInboundCtsDetails(ctsNum, branch) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getInboundCtsDetails(ctsNum, branch)
            .then(
                ctsDetails => {
                    dispatch(inboundFetched());
                    dispatch(success(ctsDetails));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(ctsDetails) { return { type: inboundConstants.INBOUND_GET_CTS_DETAILS, ctsDetails } }
}
function getInboundCtsTandemDetails(ctsNum, branch) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getInboundCtsDetails(ctsNum, branch)
            .then(
                ctsTandemDetails => {
                    dispatch(inboundFetched());
                    dispatch(success(ctsTandemDetails));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(ctsTandemDetails) { return { type: inboundConstants.INBOUND_GET_CTS_TANDEM_DETAILS, ctsTandemDetails } }
}
function createVanInEmpty(payload, isTandem) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.createVanInEmpty(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    // dispatch(getCTS(payload.ctsNum, 'clerance'));
                    let PrintLoad = payload;
                    PrintLoad[0].vanInId = success.tandemCodeIds[0];
                    if(isTandem){
                        PrintLoad[1].vanInId = success.tandemCodeIds[1];
                    }
                    VANINCLEARANCEPDF(PrintLoad);
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Van-In Empty created successfully.'));
                    setTimeout(() => {
                        window.location.href = `/inbound/van_in`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
// function updateVanInEmpty(payload, id) {
function updateVanInEmpty(payload) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        // inboundServices.updateVanInEmpty(payload, id)
        inboundServices.updateVanInEmpty(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    // dispatch(getCTS(payload.ctsNum, 'clerance'));
                    VANINCLEARANCEPDF(payload);
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('Van-In Empty updated successfully.'));
                    setTimeout(() => {
                        window.location.href = `/inbound/van_in`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function deleteVanInEmpty(id, type, userBranch) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        inboundServices.deleteVanInEmpty(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Van-In Empty was deleted successfully'));
                    if (type === 'specific') {
                        setTimeout(() => {
                            window.location.href = `/inbound/van_in`;                            
                        }, 1000);
                    }
                    else dispatch(loadVanIn(0, 20, null, userBranch));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

// Vessel Arrival Notice
function getVesselArrivalNotice(branchCode, search) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getVesselArrivalNotice(branchCode, search)
            .then(
                voyageVesselArrivalNotice => {
                    dispatch(inboundFetched());
                    // if (voyageVesselArrivalNotice.length > 0) {
                    //     dispatch(success(voyageVesselArrivalNotice));
                    // } else {
                    //     dispatch(success([]));
                    //     dispatch(alertActions.warning(voyageVesselArrivalNotice.message));
                    // }
                    dispatch(success(voyageVesselArrivalNotice));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(voyageVesselArrivalNotice) { return { type: inboundConstants.GET_VOYAGE_VESSELARRIVALNOTICE, voyageVesselArrivalNotice } }
}
function getVesselArrivalNoticeByVoyageNum(voyageNUm, branchDestination) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getVesselArrivalNoticeByVoyageNum(voyageNUm, branchDestination)
            .then(
                inboundVesselArrivalNotice => {
                    dispatch(inboundFetched());
                    dispatch(success(inboundVesselArrivalNotice));
                    if (inboundVesselArrivalNotice.message) dispatch(alertActions.warning(inboundVesselArrivalNotice.message));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(inboundVesselArrivalNotice) { return { type: inboundConstants.INBOUND_VESSEL_ARRIVAL_NOTICE, inboundVesselArrivalNotice } }
}

// CRO Clearance
function getVoyageCroClearance(search) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getVoyageCroClearance(search)
            .then(
                getVoyageCroClearance => {
                    dispatch(inboundFetched());
                    // if (getVoyageCroClearance.length > 0) {
                    //     dispatch(success(getVoyageCroClearance));
                    // } else {
                    //     dispatch(success([]));
                    //     dispatch(alertActions.warning(getVoyageCroClearance.message));
                    // }
                    dispatch(success(getVoyageCroClearance));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(getVoyageCroClearance) { return { type: inboundConstants.GET_VOYAGE_CROCLEARANCE, getVoyageCroClearance } }
}
function getCroClearance(voyageNum, branch) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getCroClearance(voyageNum, branch)
            .then(
                getCroClearance => {
                    dispatch(inboundFetched());
                    if (getCroClearance.length > 0) {
                        dispatch(success(getCroClearance));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(getCroClearance.message));
                    }
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(getCroClearance) { return { type: inboundConstants.INBOUND_GET_CROCLEARANCE, getCroClearance } }
}
function updateIsClearedCRO(voyageNum, payload, isList, branch) {
    return dispatch => {
        dispatch(inboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        inboundServices.updateIsClearedCRO(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.success('CRO Clearance Updated successfully.'));
                    if (isList) {
                        dispatch(getCroClearance(voyageNum, branch));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(inboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function getCroUnpaidWaybills(waybill) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.getCroUnpaidWaybills(waybill)
            .then(
                CroUnpaidWaybills => {
                    dispatch(inboundFetched());
                    dispatch(success(CroUnpaidWaybills));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(CroUnpaidWaybills) { return { type: inboundConstants.INBOUND_GET_CROUNPAIDWB, CroUnpaidWaybills } }
}

// Dwell Time
function inboundDwelltimeReport(payload) {
    return dispatch => {
        dispatch(inboundFetching());
        inboundServices.inboundDwelltimeReport(payload)
            .then(
                InboundDwellTime => {
                    dispatch(inboundFetched());
                    dispatch(success(InboundDwellTime));
                },
                error => {
                    dispatch(inboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(InboundDwellTime) { return { type: inboundConstants.INBOUND_DWELL_TIME, InboundDwellTime } }
}